module.exports = __webpack_public_path__ + "static/media/icons_Bilan BPCO.e55f6c25.svg";